var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-image")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-column-select", {
                    attrs: { model: _vm.model, browse: _vm.browse },
                    model: {
                      value: _vm.image.Prop,
                      callback: function ($$v) {
                        _vm.$set(_vm.image, "Prop", $$v)
                      },
                      expression: "image.Prop",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("pre-text") },
                    model: {
                      value: _vm.image.PreText,
                      callback: function ($$v) {
                        _vm.$set(_vm.image, "PreText", $$v)
                      },
                      expression: "image.PreText",
                    },
                  }),
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("post-text") },
                    model: {
                      value: _vm.image.PostText,
                      callback: function ($$v) {
                        _vm.$set(_vm.image, "PostText", $$v)
                      },
                      expression: "image.PostText",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }